// PLAN tab — the real pane (F-PLAN, option a). Composes the brief/écriture
// roster (pure BE-consumption via `useCaseStore`) + an honest ComingSoon for
// the live-document outline (gated on an Office.js heading-scan adapter that
// does not exist yet — deferred to F-PLAN-OUTLINE).
//
// Invariants:
//   W1 — no business logic. The roster lists / switches active brief only.
//        No outline derivation, no word counts, no doc mutation.
//   W2 — no Office.js. The outline is a ComingSoon precisely because reading
//        the Word doc's live outline needs a `Word.run` adapter (F-PLAN-OUTLINE).
//   W5 — no new store. Reuses `useCaseStore` (already wired into logout reset).
//   W6 — no $/tokens.
//   §9 — logical RTL utilities; BE brief titles get `bidiProps` (in BriefRoster).
//
// The mockup `panes/PanePlan.tsx` rendered OUTLINE_FIXTURES + OTHER_BRIEFS
// fixtures and a `+ Section` button (doc mutation). Both are dropped here:
// fixtures are anti-fake, doc mutation is Office.js.

import { BriefRoster } from './BriefRoster'
import { OutlineComingSoon } from './OutlineComingSoon'

export function PlanPane(): JSX.Element {
  return (
    <div data-testid="plan-pane" className="flex flex-1 flex-col">
      <BriefRoster />
      <OutlineComingSoon />
    </div>
  )
}
